
import { Box, useTheme } from '@mui/material';
import type { ReactNode } from 'react';


interface FormContainerProps {
  children: ReactNode;
}

export function FormContainer({ children }: FormContainerProps) {
    const theme = useTheme();
  return (
    <Box sx={{ p: { xs: 1, md: 4 },   background: theme.palette.background.paper, borderRadius:4, minHeight: '100vh' }}>
      <Box sx={{ 
       
        borderRadius: 4, 
        p: 4, 
        maxWidth: 900, 
        margin: '32px auto', 
        boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)' 
      }}>
        {children}
      </Box>
    </Box>
  );
}